module.exports ={
    templates: {
        all: '全部',
        add:'新 增',
        loadTip: {
            fail: '加载模板数据失败',
            permission: '您没有权限查看模板数据'
        },
        addTip: {
            success: '模板添加成功',
            exist: '模板名已存在',
            fail:'模板添加失败',
            permission: '您没有权限添加模板'
        },
        delTip:{
            msg:'确定删除{demoName}吗?删除后绑定当前模板的标签的模板将删除',
            success: '模板删除成功',
            exist: '删除的模板不存在或已被删除',
            fail:'模板删除失败',
            permission: '您没有权限删除模板'
        },
        copyTip: {
            success: '模板复制成功',
            exist: '模板名已存在',
            fail:'模板复制失败',
            permission: '您没有权限复制模板'
        },
        find:'查找模板名',
        findSize: '查找尺寸',
        findColor: '查找颜色',
        addTitle: '新建模板',
        delTitle:'删除模板',
        copyTitle: '复制模板',
        demoName: '模板名称',
        demoNameMsg: '请输入模板名称',
        demoNameFail: '获取失败,请重新输入',
        screenSize:'屏幕尺寸',
        sizeSelectMsg:'全部尺寸',
        // screenOpt:['1.54"','2.13"','2.9"','4.2"'],
        screenOpt:[1.54, 2.13, 2.66, 2.9, 4.2, 5.83, 7.5, 11.6],
        // screenOpt:[1.54,2.13,2.9,4.2,5.83,7.5],
        // screenOpt:[
        //     {
        //         label: '请选择尺寸',
        //         value: 0
        //     },{
        //         label: 1.54,
        //         value: 1.54
        //     },{
        //         label: 2.13,
        //         value: 2.13
        //     },{
        //         label: 2.9,
        //         value: 2.9
        //     },{
        //         label: 4.2,
        //         value: 4.2
        //     }
        // ],
        // screenOptDetail:['1.54" (152*152)','2.13" (212*104)','2.9" (296*128)','4.2" (400*300)'],
        demoTypes: [
            {
                label: '全部',
                value: 0
            },{
                label: '门店模板',
                value: 2
            },{
                label: '系统模板',
                value: 1
            }
        ],
        screenOptDetail:[
            {
                inch: 1.54,
                width: 152,
                height: 152,
                id: 1
            },
            {
                inch: 1.54,
                width: 200,
                height: 200,
                id: 2
            },
            // {
            //     inch: 2.13,
            //     width: 212,
            //     height: 104,
            //     id: 3
            // },
            {
                inch: 2.13,
                width: 250,
                height: 122,
                id: 3
            },
            {
                inch: 2.66,
                width: 296,
                height: 152,
                id: 4
            },
            {
                inch: 2.9,
                width: 296,
                height: 128,
                id: 5
            },
            {
                inch: 4.2,
                width: 400,
                height: 300,
                id: 6
            },
            {
                inch: 5.83,
                width: 648,
                height: 480,
                id: 7
            },
            {
                inch: 7.5,
                width: 880,
                height: 528,
                id: 8
            },
            {
                inch: 11.6,
                width: 960,
                height: 640,
                id: 10
            }
        ],
        optionalColor: '可选颜色',
        // optionalColors: [
        //     {
        //         label: '黑白红',
        //         value: 'red'
        //     },{
        //         label: '黑白黄',
        //         value: 'yellow'
        //     },{
        //         label: '黑白',
        //         value: 'black'
        //     }
        // ],
        optionalColors: {
            default: {
                label: '全部颜色',
                value: ''
            },
            red: {
                label: '黑白红',
                value: 'red'
            },
            yellow: {
                label: '黑白黄',
                value: 'yellow'
            },
            black: {
                label: '黑白',
                value: 'black'
            }
        },
        optionalColorMsg: '请选择可选颜色',
        screenOrientation: '屏幕方向',
        optionalOrientation: [
            {
                label: '水平',
                value: 0
            }, {
                label: '竖直',
                value: 1
            }
        ],
        optionalOrientationMsg: '请选择屏幕方向',
        cancel: '取 消',
        sure: '确 定',
        sampleContent: {
            proNo:'1101',
            name:'云里物里电子标签',
            proAbbr: '电子标签',
            brand: '云里物里',
            price:'￥68.00',
            origin:'中国深圳',
            rating:'A',
            piece:'个',
            specification:'2901',
            supplierName:'云里物里',
            barcodeText:'6666666666666',
            qrcodeText: 'http://minewtech.com',
            barcode:'6666666666666',
            qrcode:"http://minewtech.com"
        },
        samplePrefix: {
            proNo:'编号：',
            name:'品名：',
            proAbbr: '简称：',
            brand: '品牌：',
            price:'',
            origin:'产地：',
            rating:'等级：',
            piece:'单位：',
            specification:'规格：',
            supplierName:'供货商：',
            barcodeText:'',
            qrcodeText: ''
        },
        noData: '暂无数据',
        submiting: '提交中...',
        text: '文本'
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/zh/templates.js